/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnumGroupType = "system" | "user" | "%future added value";
export type FilterFindManyGroupInput = {
    user?: string | null | undefined;
    _id?: string | null | undefined;
    deleted?: number | null | undefined;
    createdAt?: unknown | null | undefined;
    updatedAt?: unknown | null | undefined;
    createdBy?: string | null | undefined;
    updatedBy?: string | null | undefined;
    deletedBy?: string | null | undefined;
    deletedAt?: unknown | null | undefined;
    name?: string | null | undefined;
    type?: EnumGroupType | null | undefined;
    users?: Array<string | null> | null | undefined;
    facilities?: Array<string | null> | null | undefined;
    allFacilities?: boolean | null | undefined;
    _ids?: Array<string | null> | null | undefined;
    _operators?: OperatorsFilterFindManyGroupInput | null | undefined;
    OR?: Array<FilterFindManyGroupInput> | null | undefined;
    AND?: Array<FilterFindManyGroupInput> | null | undefined;
};
export type OperatorsFilterFindManyGroupInput = {
    user?: UserOperatorsFilterFindManyGroupInput | null | undefined;
    _id?: _idOperatorsFilterFindManyGroupInput | null | undefined;
    deleted?: DeletedOperatorsFilterFindManyGroupInput | null | undefined;
    createdAt?: CreatedAtOperatorsFilterFindManyGroupInput | null | undefined;
    updatedAt?: UpdatedAtOperatorsFilterFindManyGroupInput | null | undefined;
    createdBy?: CreatedByOperatorsFilterFindManyGroupInput | null | undefined;
    updatedBy?: UpdatedByOperatorsFilterFindManyGroupInput | null | undefined;
    deletedBy?: DeletedByOperatorsFilterFindManyGroupInput | null | undefined;
    deletedAt?: DeletedAtOperatorsFilterFindManyGroupInput | null | undefined;
    name?: NameOperatorsFilterFindManyGroupInput | null | undefined;
    type?: TypeOperatorsFilterFindManyGroupInput | null | undefined;
    users?: UsersOperatorsFilterFindManyGroupInput | null | undefined;
    facilities?: FacilitiesOperatorsFilterFindManyGroupInput | null | undefined;
    allFacilities?: AllFacilitiesOperatorsFilterFindManyGroupInput | null | undefined;
};
export type UserOperatorsFilterFindManyGroupInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type _idOperatorsFilterFindManyGroupInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedOperatorsFilterFindManyGroupInput = {
    gt?: number | null | undefined;
    gte?: number | null | undefined;
    lt?: number | null | undefined;
    lte?: number | null | undefined;
    ne?: number | null | undefined;
    in?: Array<number | null> | null | undefined;
    nin?: Array<number | null> | null | undefined;
    regex?: number | null | undefined;
};
export type CreatedAtOperatorsFilterFindManyGroupInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type UpdatedAtOperatorsFilterFindManyGroupInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type CreatedByOperatorsFilterFindManyGroupInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type UpdatedByOperatorsFilterFindManyGroupInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedByOperatorsFilterFindManyGroupInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedAtOperatorsFilterFindManyGroupInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type NameOperatorsFilterFindManyGroupInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type TypeOperatorsFilterFindManyGroupInput = {
    gt?: EnumGroupType | null | undefined;
    gte?: EnumGroupType | null | undefined;
    lt?: EnumGroupType | null | undefined;
    lte?: EnumGroupType | null | undefined;
    ne?: EnumGroupType | null | undefined;
    in?: Array<EnumGroupType | null> | null | undefined;
    nin?: Array<EnumGroupType | null> | null | undefined;
    regex?: EnumGroupType | null | undefined;
};
export type UsersOperatorsFilterFindManyGroupInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type FacilitiesOperatorsFilterFindManyGroupInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type AllFacilitiesOperatorsFilterFindManyGroupInput = {
    gt?: boolean | null | undefined;
    gte?: boolean | null | undefined;
    lt?: boolean | null | undefined;
    lte?: boolean | null | undefined;
    ne?: boolean | null | undefined;
    in?: Array<boolean | null> | null | undefined;
    nin?: Array<boolean | null> | null | undefined;
    regex?: boolean | null | undefined;
};
export type FilterGroupDataEmbedQueryVariables = {
    filter?: FilterFindManyGroupInput | null | undefined;
};
export type FilterGroupDataEmbedQueryResponse = {
    readonly " $fragmentRefs": FragmentRefs<"FilterGroupList_EmbedQuery">;
};
export type FilterGroupDataEmbedQuery = {
    readonly response: FilterGroupDataEmbedQueryResponse;
    readonly variables: FilterGroupDataEmbedQueryVariables;
};



/*
query FilterGroupDataEmbedQuery(
  $filter: FilterFindManyGroupInput
) {
  ...FilterGroupList_EmbedQuery
}

fragment FilterGroupList_EmbedQuery on Query {
  groupConnection(first: 25, filter: $filter, sort: NAME_ASC) {
    edges {
      node {
        _id
        name
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 25
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": "NAME_ASC"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FilterGroupDataEmbedQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "FilterGroupList_EmbedQuery"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FilterGroupDataEmbedQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GroupConnection",
        "kind": "LinkedField",
        "name": "groupConnection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GroupEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Group",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "_id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "filter",
          "sort"
        ],
        "handle": "connection",
        "key": "FilterGroupList_groupConnection",
        "kind": "LinkedHandle",
        "name": "groupConnection"
      }
    ]
  },
  "params": {
    "cacheID": "1480a379b2b0a8ef33f757cc769ee403",
    "id": null,
    "metadata": {},
    "name": "FilterGroupDataEmbedQuery",
    "operationKind": "query",
    "text": "query FilterGroupDataEmbedQuery(\n  $filter: FilterFindManyGroupInput\n) {\n  ...FilterGroupList_EmbedQuery\n}\n\nfragment FilterGroupList_EmbedQuery on Query {\n  groupConnection(first: 25, filter: $filter, sort: NAME_ASC) {\n    edges {\n      node {\n        _id\n        name\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'f2af1efa0d4a6c5fe0dc7d248f9495e6';
export default node;
